<template>
  <DxDropDownBox
    :ref="dropDownBoxRefName"
    :drop-down-options="dropDownOptions"
    
    :value.sync="currentValue"
    :display-expr="cellEditing"
    value-expr="Id"
    content-template="contentTemplate"
  >
    <template #contentTemplate="{}">
      <div >
        <div class="text-input">
           <label><b>{{cellEditing}}</b></label>
          <div class="input-group">
            <input 
              v-if="open"
              v-focus 
              type="text"
              class="form-control"
              placeholder=""  
              :style="{marginBottom: '10px'}"
              v-model="currentValue"
              @keydown.tab="finishEditing"
              @keydown.enter="finishEditing"
              @change="customInputChanged"
              ref="searchInput"
              aria-label="Description">
          </div>
        </div>
        <!-- <BasicTextInput 
          :customStyles="{marginBottom: '10px'}"
          label="Description" placeholder="search..." ref="searchInput" v-model="customInput"/> -->
        <DxDataGrid
          :data-source="dataSource"
          :keyExpr="dataGridKey"
          :remote-operations="true"
          :height="300"
          :selected-row-keys="[currentValue]"
          :hover-state-enabled="true"
          :on-selection-changed="onSelectionChanged"
          :focused-row-enabled="true"
          :focused-row-key="currentValue"
          :show-borders="true"
          key-expr="PartNumber"
        >

        <DxFilterRow :showOperationChooser="false" :visible="true"/>
          <DxSearchPanel :text="searchInput" :visible="true" :width="460"/>
          <DxColumn :width="30" data-field="Id" cell-template="grid-cell"/>
          <DxColumn :width="75" data-field="MfgCode" cell-template="grid-cell"/>
          <DxColumn :width="75" data-field="PartNumber" cell-template="grid-cell"/>
          <DxColumn :width="150" caption="Description" data-field="Description" cell-template="grid-cell"/>
          <DxColumn :width="75" data-field="StockCode" cell-template="grid-cell"/>
          <DxColumn :width="50" data-field="Retail" cell-template="grid-cell-amount"/>
          <template  #grid-cell="{ data }">
            <div class="cell" style="fontSize:10px">{{ data.text }}</div>
        </template>
          <template  #grid-cell-amount="{ data }">
              <div class="cell">${{ formatCurrency(data.value) }}</div>
          </template>
          <DxPaging
            :enabled="true"
            :page-size="50"
          />
          <DxScrolling mode="virtual"/>
          <DxSelection mode="single"/>
        </DxDataGrid>
        <span class="my-5"></span>
      </div>
    </template>
  </DxDropDownBox>
</template>
<script>

import {
  DxDataGrid,
  DxPaging,
  DxSelection,
  DxScrolling,
  DxColumn,
  DxSearchPanel,
  DxFilterRow,
} from 'devextreme-vue/data-grid';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import BasicTextInput from '../components/inputComponents/BasicTextInput';
import {ProductService} from '@/services';
import { on, off } from "devextreme/events";
// const dropDownBoxRefName = 'dropDownBoxRef';

// import { getDataSource }    from "../modules/helpers.js";
// let dataSource = getDataSource('Products')

export default {
  components: {
    DxSearchPanel,
    DxDataGrid,
    DxPaging,
    DxSelection,
    DxScrolling,
    DxColumn,
    DxDropDownBox,
    DxFilterRow
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onValueChanged: {
      type: Function,
      default: () => {}
    },
    // dataSource: {
    //   type: Array,
    //   default: () => {}
    // },
    cellEditing:{
      type: String,
      default: 'Description'
    }
  },
  data() {
    return {
      dataSource: [],
      dataGridKey: 'Id',
      currentValue: null,
      dropDownOptions: { width: 500 },
      dropDownBoxRefName: 'dropDownBoxRef',
      customInput: '',
      open: false,
      timerId: null,
      searchInput: '',
    };
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
      }
    }
  },
  methods: {
    debounce(func, wait) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(func, wait)
    },
    finishEditing(e){
      console.log('tab pressed', e) 
      this.$refs[this.dropDownBoxRefName].instance.close();
    }, 
    onSelectionChanged(selectionChangedArgs) {
      console.log('selection changed args', selectionChangedArgs)
      if(selectionChangedArgs.selectedRowsData.length === 0) return;
      this.currentValue = selectionChangedArgs.selectedRowsData[0][this.cellEditing];
      this.onValueChanged(this.currentValue);
      this.$emit('setProductData', selectionChangedArgs.selectedRowsData[0])
      if(selectionChangedArgs.selectedRowKeys.length > 0) {
        if(!this.$refs[this.dropDownBoxRefName]) return;
        this.$refs[this.dropDownBoxRefName].instance.close();
      }
    },

    async openGrid(){
      await this.$refs[this.dropDownBoxRefName].instance.open()
      // console.log('this.$refs',this.$refs[this.dropDownBoxRefName])
      setTimeout(() => {
        this.open = true;
      }, 25)
      // this.focusInput()
      // Vue.nextTick(() => {
      //   this.focusInput
      // })
    
      

    },
    formatCurrency(currency){
      if(typeof(currency) !== 'number') return;
      return currency.toFixed(2);
    },
    // showInput(){
    //   this.inputIsFocused = true
    //   this.$nextTick(() => {
    //     this.focusInput();
    //   });
    // },
    // focusInput() {
    //   this.$nextTick(()=>{
    //     this.$refs.searchInput.focus();
    //   })
      
    // },
    // inputChanged($event){
    //   this.$emit('input',$event.target.value)
    //   // this.debounce(()=>{this.searchInput = $event.target.value}, 500);
    // },
    // searchInputChanged($event){
    //   this.$emit('input',$event.target.value)
    //   this.debounce(()=>{this.searchInput = $event.target.value}, 500);
    // },
    customInputChanged() {
      
      // this.currentValue = this.customInput;
      this.onValueChanged(this.currentValue)
    },
    getProducts(){
      this.dataSource = ProductService.getDataSource();
    }
  },
  watch: {
    // customInput: function () {
    //   this.currentValue = this.customInput
    //   this.onValueChanged(this.currentValue)
    //   // this.$emit('resetRowValues', this.currentValue)
    // }
    // open: function(){
    //   this.focusInput()
    // }
  },
  mounted(){
    console.log('mounted dropdownbox', this.dropDownBoxRefName, this.$refs);
    this.openGrid();
    
    
  },
  created(){
    console.log('combobox created', this.value)
    this.currentValue = this.value;
    this.getProducts();
  }
};
</script>
<style lang="scss" scoped>

  .header {
    color: $primary;
    font-size: 12px;
  }
  .cell {
    color: $ss_grey1;
    font-size: 10px;
  }
</style>
